import { Button, Input, List, Modal, Spin, Typography } from 'antd'
import React, { useCallback } from 'react'
import { PricingAPI } from '../../../../../controller/PricingAPI';
// import TodoCard from './TodoCard';
import TodoItem from './TodoItem';
import { notifyTodosChanged, showRequestError } from '../todoHelpers';


function TodoListPaneContent({ state, scope, refreshTime, onEdit, onChanged }) {
    const [pagination, setPagination] = React.useState({
        current: 1,
        pageSize: 5,
    });
    const [total, setTotal] = React.useState(0);
    const [loading, setLoading] = React.useState(false);
    const [details, setDetails] = React.useState([]);

    const [updateStateLoading, setUpdateStateLoading] = React.useState(false);
    const [updateStateModal, setUpdateStateModal] = React.useState({
        open: false,
        todoId: null,
        state: null // 'ignored' or 'completed'
    });
    const [editNoteLoading, setEditNoteLoading] = React.useState(false);
    const [editNoteModal, setEditNoteModal] = React.useState({
        open: false,
        todoId: null,
        noteId: null
    });
    const [editNote, setEditNote] = React.useState('');
    const [note, setNote] = React.useState('');

    // {
    //     "id": 7,
    //     "subject": "2025/02/22 請評估是否需安排額外人力，最近 9 個月住房率超過 5 成的日期",
    //     "description": "<table border=\"1\" cellspacing=\"0\" cellpadding=\"8\" style=\"width:100%; border-collapse: collapse;\">\n\t<thead>\n\t\t<tr>\n\t\t\t<th style=\"text-align: left;\">日期</th>\n\t\t\t<th style=\"text-align: right;\">住房間數</th>\n\t\t\t<th style=\"text-align: right;\">平均含餐價格</th>\n\t\t</tr>\n\t</thead>\n\t<tbody>\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<span style=\"text-decoration: line-through;\">\n\t\t\t\t\t\t\t2025/02/22 (六)\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td></td>\n\t\t\t\t\t<td></td>\n\t\t\t\t</tr>\n\t\t\t\t\t\t\n\t\t\t\n\t\t\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t<td>2025/02/28 (五)</td>\n\t\t\t\t\t<td style=\"text-align: right;\">\n\t\t\t\t\t\t80\n\t\t\t\t\t\t\t\t\t\t\t\t<span style=\"color:green\">\n\t\t\t\t\t\t\t(+3)\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td style=\"text-align: right;\">5825</td>\n\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t<td>2025/03/01 (六)</td>\n\t\t\t\t\t<td style=\"text-align: right;\">\n\t\t\t\t\t\t73\n\t\t\t\t\t\t\t\t\t\t\t\t<span style=\"color:green\">\n\t\t\t\t\t\t\t(+4)\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td style=\"text-align: right;\">5776</td>\n\t\t\t\t</tr>\n\t\t\t\t\t\t</tbody>\n\t</table>\n\t",
    //     "processuser_id": null,
    //     "state": "new",
    //     "processingtime": null,
    //     "ignoredtime": null,
    //     "completedtime": null,
    //     "created_at": "2025-02-22T01:00:03.000000Z",
    //     "updated_at": "2025-02-22T01:00:03.000000Z",
    //     "processuser": null
    // },

    const refresh = useCallback(() => {
        setLoading(true);
        PricingAPI.todos.index({
            state: state,
            scope: scope
        }, pagination.current, pagination.pageSize).then((response) => {
            const result = response.data;
            setTotal(result.total);
            setDetails(result.data);
        }).catch(showRequestError).finally(() => {
            setLoading(false);
        });
    }, [pagination, state, scope])

    React.useEffect(() => {
        refresh();
    }, [refresh, refreshTime]);

    const handleShowCompleteModal = useCallback((todoId) => {
        setUpdateStateModal({
            open: true,
            todoId: todoId,
            state: 'completed'
        });
    }, []);
    const handleHideModal = useCallback(() => {
        setUpdateStateModal({
            open: false,
            todoId: null,
            state: null
        });
    }, []);

    const handleChangeNote = useCallback((e) => {
        setNote(e.target.value);
    }, []);

    const handleIgnore = useCallback((todoId) => {
        setUpdateStateLoading(true);
        PricingAPI.todos.updateState(todoId, {
            state: 'ignored',
        }).then(() => {
            refresh();
            notifyTodosChanged();
        }).catch(showRequestError).finally(() => {
            setUpdateStateLoading(false);
        });
        // }).then((response) => {
        //     // refresh();
        //     const newDetails = [...details.filter((item) => item.id !== todoId)];
        //     console.log(response);
        //     if (response.data && (response.data.state === state || state === 'all')) {
        //         newDetails.push(response.data);
        //     }
        //     setDetails(newDetails);
        // }).finally(() => {
        //     setUpdateStateLoading(false);
        // }, []);
    }, [refresh]);
    const handleComplete = useCallback((todoId, note) => {
        setUpdateStateLoading(true);
        PricingAPI.todos.updateState(todoId, {
            state: 'completed',
            note: note
        }).then(() => {
            refresh();
            notifyTodosChanged();
        }).catch(showRequestError).finally(() => {
            setUpdateStateLoading(false);
        });
    }, [refresh]);
    const handleUndo = useCallback((todoId) => {
        setUpdateStateLoading(true);
        PricingAPI.todos.updateState(todoId, {
            state: 'new',
        }).then(() => {
            refresh();
            notifyTodosChanged();
        }).catch(showRequestError).finally(() => {
            setUpdateStateLoading(false);
        });
    }, [refresh]);
    // 通知頁面讓所有清單 (含待我處理與各頁籤) 一起重抓；沒有提供時只重抓自己
    const refreshAll = useCallback(() => {
        if (onChanged) {
            onChanged();
        } else {
            refresh();
        }
    }, [onChanged, refresh]);

    const handleClaim = useCallback((todoId) => {
        setUpdateStateLoading(true);
        PricingAPI.todos.claim(todoId).then(() => {
            // 防禦性重抓：別人可能同時改了同一筆，回到第 1 頁避免停在空白的後面頁
            setPagination((prev) => (prev.current === 1 ? prev : { ...prev, current: 1 }));
            refreshAll();
            notifyTodosChanged();
        }).catch((error) => {
            showRequestError(error);
            // 任何失敗都重抓 (409 被別人搶走、404 已不存在)，讓畫面與後端一致
            refresh();
        }).finally(() => {
            setUpdateStateLoading(false);
        });
    }, [refresh, refreshAll]);

    const handleRelease = useCallback((todoId) => {
        setUpdateStateLoading(true);
        PricingAPI.todos.release(todoId).then(() => {
            refreshAll();
            notifyTodosChanged();
        }).catch(showRequestError).finally(() => {
            setUpdateStateLoading(false);
        });
    }, [refreshAll]);
    const handleOkModal = useCallback(() => {
        console.log('ok');
        if (updateStateModal.state === 'ignored') {
            handleIgnore(updateStateModal.todoId, note);
        }
        if (updateStateModal.state === 'completed') {
            handleComplete(updateStateModal.todoId, note);
        }
        setNote('');
        handleHideModal();
    }, [updateStateModal.state, updateStateModal.todoId, handleHideModal, handleIgnore, note, handleComplete]);

    const handleShowNoteEdit = useCallback((todoId, noteId) => {
        console.log('edit note', todoId, noteId);
        setEditNoteLoading(true);
        setEditNoteModal({
            open: true,
            todoId: todoId,
            noteId: noteId
        });
        PricingAPI.todos.notes.show(todoId, noteId).then((response) => {
            setEditNote(response.data.note);
        }).finally(() => {
            setEditNoteLoading(false);
        });
    }, []);
    const handleHideEditNoteModal = useCallback(() => {
        setEditNoteModal({
            open: false,
            todoId: null,
            noteId: null
        });
    }, []);
    const handleEditNote = useCallback(() => {
        const todoId = editNoteModal.todoId;
        const noteId = editNoteModal.noteId;
        PricingAPI.todos.notes.update(todoId, noteId, {
            note: editNote
        }).then(() => {
            handleHideEditNoteModal();
            refresh();
        }).catch(showRequestError);
    }, [editNote, editNoteModal.noteId, editNoteModal.todoId, handleHideEditNoteModal, refresh]);
    const handleChangeEditNote = useCallback((e) => {
        setEditNote(e.target.value);
    }, []);

    const handleDeleteNote = useCallback(() => {
        const todoId = editNoteModal.todoId;
        const noteId = editNoteModal.noteId;
        PricingAPI.todos.notes.destroy(todoId, noteId).then(() => {
            handleHideEditNoteModal();
            refresh();
        }).catch(showRequestError);
    }, [editNoteModal.noteId, editNoteModal.todoId, handleHideEditNoteModal, refresh]);
    return <>
        <List
            loading={loading}
            dataSource={details}
            pagination={{
                showSizeChanger: true,
                current: pagination.current,
                pageSize: pagination.pageSize,
                total: total,
                onChange: (page, pageSize) => {
                    setPagination({
                        current: page,
                        pageSize: pageSize
                    });
                }
            }}
            renderItem={(item) => (
                <List.Item style={{ padding: '3px 0' }}>
                    <TodoItem
                        item={item}
                        onCompleted={handleShowCompleteModal}
                        onIgnored={handleIgnore}
                        onUndo={handleUndo}
                        onNoteEdit={handleShowNoteEdit}
                        onEdit={onEdit}
                        onClaim={handleClaim}
                        onRelease={handleRelease}
                        loading={updateStateLoading}
                        onItemsChanged={refreshAll}
                    />
                </List.Item>
            )}
        />
        <Modal title={`${updateStateModal.state === 'completed' ? '完成' : '略過'}待辦事項`} visible={updateStateModal.open} onOk={handleOkModal} onCancel={handleHideModal}>
            <Typography>請輸入工作摘要</Typography>
            <br />
            <Input.TextArea rows={5} placeholder="請輸入工作摘要" value={note} onChange={handleChangeNote} />
        </Modal>
        <Modal
            title="編輯工作摘要"
            visible={editNoteModal.open}
            onOk={handleEditNote}
            onCancel={handleHideEditNoteModal}
            footer={[
                <Button key="delete" type="danger" onClick={handleDeleteNote}>
                    刪除
                </Button>,
                <Button key="back" onClick={handleHideEditNoteModal}>
                    取消
                </Button>,
                <Button key="submit" type="primary" onClick={handleEditNote}>
                    送出
                </Button>,
            ]}
        >
            <Spin spinning={editNoteLoading}>
                <Typography>請輸入工作摘要</Typography>
                <br />
                <Input.TextArea rows={5} placeholder="請輸入工作摘要" value={editNote} onChange={handleChangeEditNote} />
            </Spin>
        </Modal>
    </>
}

export default TodoListPaneContent;